import APIClient from './index';

export const getCreatorFeedback = async filters => {
  const response = await APIClient.get('/AdminStrategyFeedback', { params: filters });
  return response.data;
};

export const exportCreatorFeedback = async filters => {
  const response = await APIClient.get('/AdminStrategyFeedback', { params: { ...filters, format: 'csv' }, responseType: 'blob' });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'creator-feedback.csv';
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
